var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { attrs: { "vs-align": "left", "vs-w": "6" } },
            [
              _c(
                "vs-button",
                {
                  attrs: {
                    color: "primary",
                    type: "filled",
                    "icon-pack": "feather",
                    icon: "icon-plus",
                  },
                  on: { click: _vm.showFormCreate },
                },
                [_vm._v("\n                Ajouter une trame\n            ")]
              ),
              _vm._v(" "),
              _c(
                "DialogPrompt",
                {
                  attrs: {
                    active: _vm.showPopup,
                    title: _vm.getDataPrompt.title,
                    "cancel-text": "Annuler",
                    "accept-text": "Enregistrer",
                    "button-accept": _vm.getDataPrompt.btnAccept,
                    "is-valid": !_vm.formError,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.showPopup = $event
                    },
                    cancel: _vm.resetResource,
                    close: _vm.resetResource,
                    accept: _vm.saveResource,
                  },
                },
                [
                  _c(
                    "vs-row",
                    [
                      _c(
                        "vs-col",
                        [
                          _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "name",
                              label: "Nom de la trame",
                              required: "",
                            },
                            model: {
                              value: _vm.resource.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource, "name", $$v)
                              },
                              expression: "resource.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-row",
                    { staticClass: "mt-10 mb-3" },
                    [_c("vs-col", [_c("h5", [_vm._v("Champs de synthèse")])])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-row",
                    [
                      _c(
                        "vs-col",
                        { attrs: { "vs-w": "12" } },
                        [
                          _c("p", [_vm._v("Ajouter un champ de synthèse :")]),
                          _vm._v(" "),
                          _c(
                            "vx-input-group",
                            [
                              _c("vs-input", {
                                staticClass: "w-full",
                                attrs: {
                                  name: "textZone",
                                  placeholder: "Intitulé du champ de synthèse",
                                  required: "",
                                },
                                model: {
                                  value: _vm.tempQuestion,
                                  callback: function ($$v) {
                                    _vm.tempQuestion = $$v
                                  },
                                  expression: "tempQuestion",
                                },
                              }),
                              _vm._v(" "),
                              _c("vs-input", {
                                attrs: { type: "hidden" },
                                model: {
                                  value: _vm.tempQuestionType,
                                  callback: function ($$v) {
                                    _vm.tempQuestionType = $$v
                                  },
                                  expression: "tempQuestionType",
                                },
                              }),
                              _vm._v(" "),
                              _c("template", { slot: "append" }, [
                                _c(
                                  "div",
                                  { staticClass: "append-text btn-addon" },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        attrs: {
                                          id: "addTextZone",
                                          "icon-pack": "feather",
                                          icon: "icon-plus",
                                          disabled:
                                            !_vm.tempQuestion ||
                                            !_vm.tempQuestion.trim().length,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.addQuestion.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Ajouter\n                                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-row",
                    [
                      _c(
                        "vs-col",
                        [
                          _vm.resource.fields.length > 0
                            ? _c(
                                "vs-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "max-items": "10",
                                    data: _vm.orderedResourceQuestions,
                                    "no-data-text": "Aucune donnée à afficher",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ data }) {
                                          return _vm._l(
                                            data,
                                            function (item, i) {
                                              return _c(
                                                "tr",
                                                {
                                                  key: i,
                                                  class:
                                                    !!_vm.dragging &&
                                                    _vm.dragging.id == item.id
                                                      ? "dragging"
                                                      : "waiting-drag",
                                                  attrs: { data: item },
                                                },
                                                [
                                                  _c("vs-td", [
                                                    _c("div", {
                                                      staticClass: "drag-icon",
                                                      attrs: {
                                                        draggable: "true",
                                                      },
                                                      on: {
                                                        dragstart: function (
                                                          $event
                                                        ) {
                                                          return _vm.dragStart(
                                                            item,
                                                            $event
                                                          )
                                                        },
                                                        dragover: function (
                                                          $event
                                                        ) {
                                                          return _vm.dragOver(
                                                            item.order,
                                                            $event
                                                          )
                                                        },
                                                        drop: function (
                                                          $event
                                                        ) {
                                                          return _vm.drop(
                                                            item.order,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "vs-td",
                                                    {
                                                      attrs: {
                                                        data: item.order,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(item.order) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("vs-td", [
                                                    _vm.questionEditing === i
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "vx-input-group",
                                                              [
                                                                _c("vs-input", {
                                                                  staticClass:
                                                                    "w-full",
                                                                  attrs: {
                                                                    name: "textZone",
                                                                    placeholder:
                                                                      "Nom",
                                                                    required:
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.label,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "label",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.label",
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("vs-input", {
                                                                  attrs: {
                                                                    type: "hidden",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.type,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "type",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.type",
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "append",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "append-text btn-addon",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "vs-button",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "icon-pack":
                                                                                  "feather",
                                                                                icon: "icon-edit",
                                                                                disabled:
                                                                                  !item.label ||
                                                                                  !item.label.trim()
                                                                                    .length,
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.preventDefault()
                                                                                  return _vm.updateResource()
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                            Enregistrer\n                                                        "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _c("div", [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                item.label
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.resource.fields.length >
                                                    1 &&
                                                  _vm.questionEditing != i
                                                    ? _c(
                                                        "vs-td",
                                                        [
                                                          _c("vs-button", {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value:
                                                                  "Modifier",
                                                                expression:
                                                                  "'Modifier'",
                                                              },
                                                            ],
                                                            attrs: {
                                                              color: "primary",
                                                              type: "border",
                                                              "icon-pack":
                                                                "feather",
                                                              icon: "icon-edit",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.editQuestion(
                                                                  i
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("vs-button", {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value:
                                                                  "Supprimer",
                                                                expression:
                                                                  "'Supprimer'",
                                                              },
                                                            ],
                                                            staticStyle: {
                                                              "margin-left":
                                                                "1rem",
                                                            },
                                                            attrs: {
                                                              color: "primary",
                                                              type: "border",
                                                              "icon-pack":
                                                                "feather",
                                                              icon: "icon-trash",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteQuestion(
                                                                  i
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2676489681
                                  ),
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "thead" },
                                    [
                                      _c("vs-th", {
                                        staticStyle: { width: "15px" },
                                      }),
                                      _vm._v(" "),
                                      _c("vs-th", [
                                        _vm._v(
                                          "\n                                    Ordre\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("vs-th", [
                                        _vm._v(
                                          "\n                                    Nom\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "vs-th",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.resource.fields.length > 1,
                                              expression:
                                                "resource.fields.length > 1",
                                            },
                                          ],
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    Action\n                                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vs-row",
        { staticClass: "mt-3" },
        [
          _c(
            "vs-col",
            { attrs: { "vs-w": "12" } },
            [
              _c(
                "vs-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    sst: true,
                    "no-data-text": _vm.loading
                      ? `Chargement de vos données...`
                      : `Aucune donnée à afficher`,
                    data: _vm.items.data,
                    loading: _vm.items.loading,
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c("vs-th", [
                        _vm._v(
                          "\n                        #\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-th", [
                        _vm._v(
                          "\n                        Nom\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-th", [
                        _vm._v(
                          "\n                        Nombre de champs de synthèse\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-th", { staticClass: "text-right pr-6" }, [
                        _vm._v(
                          "\n                        Action\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.items.data, function (item, i) {
                    return _c(
                      "vs-tr",
                      { key: i },
                      [
                        _c("vs-td", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.id) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("vs-td", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.name) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("vs-td", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.fields.length) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("vs-td", { staticClass: "action" }, [
                          _c(
                            "div",
                            { staticClass: "action-wrapper" },
                            [
                              _c("vs-button", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Modifier",
                                    expression: "'Modifier'",
                                  },
                                ],
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  "icon-pack": "feather",
                                  icon: "icon-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.showFormUpdate(item)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("vs-button", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Supprimer",
                                    expression: "'Supprimer'",
                                  },
                                ],
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  "icon-pack": "feather",
                                  icon: "icon-trash",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.removeResource(item)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }